module.exports = __webpack_public_path__ + "static/media/ehealth_bpbg_banner_desktop.6e46371e.jpg";